import { watch } from 'vue';
import type { ClientNavigationContext } from 'shared';
import { updateClientActivity } from '@/composables/useCollaborationSocket';
import { monitorFeature } from '@/utils/monitor-activity';

/** 各前端入口共用上报链路，直接观察路由和已有 Store，不保存业务状态副本。 */
export function useClientNavigationContext(resolve: () => ClientNavigationContext): void {
  watch(
    resolve,
    (navigation) => updateClientActivity(monitorFeature(navigation.routeName ?? ''), navigation),
    { immediate: true },
  );
}
